/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_List_Interview_Outcome_PendingInputs */

const en_admin_user_list_interview_outcome_pending = /** @type {(inputs: Admin_User_List_Interview_Outcome_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmation pending`)
};

const de_admin_user_list_interview_outcome_pending = /** @type {(inputs: Admin_User_List_Interview_Outcome_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigung offen`)
};

/**
* | output |
* | --- |
* | "Confirmation pending" |
*
* @param {Admin_User_List_Interview_Outcome_PendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_interview_outcome_pending = /** @type {((inputs?: Admin_User_List_Interview_Outcome_PendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_Interview_Outcome_PendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_interview_outcome_pending(inputs)
	return en_admin_user_list_interview_outcome_pending(inputs)
});